import * as React from 'react';

import { isEqual } from 'lodash';

import { Button } from '@coursera/cds-core';
import { ContextualHelpIcon } from '@coursera/cds-icons';
import { Box } from '@coursera/coursera-ui';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import SearchBar from '@coursera/coursera-ui/lib/components/extended/TableV2/ToolbarTable/SearchBar';

import { org_coursera_skill_GoalType as GoalType } from 'bundles/enterprise-admin-skills/components/__generated__/globalTypes';
import { LabelText, Spacer } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/enterprise-admin-skills';

const radioButton: React.CSSProperties = {
  marginRight: '4px',
};

const RadioButtons = ({
  options,
  value,
  onChange,
}: {
  options: { label: string; value: string[]; id: string }[];
  value: string[];
  onChange: (value: string[]) => void;
}) => {
  return (
    <Box>
      {options.map((option) => (
        <Button
          key={option.id}
          variant={isEqual(value, option.value) ? 'primary' : 'secondary'}
          onClick={() => {
            onChange(option.value);
          }}
          style={radioButton}
        >
          {option.label}
        </Button>
      ))}
    </Box>
  );
};

const ToggleButtons = ({
  options,
  value,
  onChange,
}: {
  options: { label: string; value: boolean; id: string }[];
  value: boolean;
  onChange: (value: boolean) => void;
}) => {
  return (
    <Box>
      {options.map((option) => (
        <Button
          key={option.id}
          variant={isEqual(value, option.value) ? 'primary' : 'secondary'}
          onClick={() => {
            onChange(option.value);
          }}
          style={radioButton}
        >
          {option.label}
        </Button>
      ))}
    </Box>
  );
};

const searchBarColumn: React.CSSProperties = { width: '356px' };

const SkillSelectionFilters = ({
  searchText,
  onSearchTextChange,
  lure,
  onLureChange,
  hasSkillSetsInScope,
  filterScopeDuplicates,
  onFilterSkillSetsInScope,
  isProgramScope,
  onAboutSkillSetTypes,
}: {
  searchText?: string;
  onSearchTextChange: (value: string) => void;
  lure: string[];
  onLureChange: (value: string[]) => void;
  hasSkillSetsInScope: boolean;
  filterScopeDuplicates: boolean;
  onFilterSkillSetsInScope: (value: boolean) => void;
  isProgramScope?: boolean;
  onAboutSkillSetTypes: () => void;
}) => (
  <Box>
    <div style={searchBarColumn} data-e2e="skillset-name-search">
      <LabelText>{_t('Filter by SkillSet name')}</LabelText>
      <Spacer size={12} />
      <SearchBar value={searchText} onUpdate={onSearchTextChange} placeholder={_t('Search by SkillSet name')} />
    </div>
    <Spacer size={32} />
    <div data-e2e="lure">
      <Box justifyContent="between">
        <LabelText>{_t('Filter by SkillSet type')}</LabelText>
        <Button
          style={{ padding: 0 }}
          variant="ghost"
          size="small"
          iconPosition="before"
          icon={<ContextualHelpIcon />}
          onClick={onAboutSkillSetTypes}
        >
          {_t('About SkillSet types')}
        </Button>
      </Box>
      <Spacer size={12} />
      <RadioButtons
        options={[
          { id: 'all-values', label: _t('All types'), value: [GoalType.LITERACY, GoalType.UPSKILL, GoalType.RESKILL] },
          { id: 'literacy', label: _t('Literacy'), value: [GoalType.LITERACY] },
          { id: 'upskill', label: _t('Upskill'), value: [GoalType.UPSKILL] },
          { id: 'reskill', label: _t('Reskill'), value: [GoalType.RESKILL] },
        ]}
        value={lure}
        onChange={onLureChange}
      />
    </div>
    {hasSkillSetsInScope && (
      <Box>
        <Spacer size={32} />
        <div data-e2e="already-in-the-org">
          <LabelText>
            {isProgramScope ? _t('SkillSets in your program.') : _t('SkillSets already in your org.')}
          </LabelText>
          <Spacer size={12} />
          <ToggleButtons
            options={[
              { id: 'show', label: _t('Show'), value: false },
              { id: 'hide', label: _t('Hide'), value: true },
            ]}
            value={filterScopeDuplicates}
            onChange={onFilterSkillSetsInScope}
          />
        </div>
      </Box>
    )}
  </Box>
);

export default SkillSelectionFilters;
